import { inject } from '@angular/core';

import { LazyBootstrapService } from './lazy-bootstrap.service';
import { CoralProductService } from './product.service';

export const coralProductActivateGuard = () => {
    inject(CoralProductService).activateCM();
    return inject(LazyBootstrapService).onLCGAppInit();
};

export const coralProductDeactivateGuard = () => {
    inject(CoralProductService).deactivateCM();
};
